import { Body, Caption, Row } from 'src/components';
import { IconSize, Size } from 'src/constants';
import { palette, Weight } from 'src/theme';
import styled from 'styled-components/native';

export const PET_ID_IMAGE_SIZE = 185;

export const ImageContainer = styled.View`
  width: 100%;
  align-items: center;
  border-width: 1px;
  border-color: ${({ theme }) => theme.colors.opaquePlaceholder};
  justify-content: center;
  margin-right: ${Size.X2_S}px;
`;

export const PatientImage = styled.Image`
  width: 100%;
  aspect-ratio: 4/3;
`;

export const PracticeLogo = styled.Image`
  height: ${Size.X4_L}px;
  width: ${Size.X5_L}px;
`;

export const TableRow = styled.View`
  flex-direction: row;
  justify-content: space-between;
`;

export const IconContainer = styled.View`
  width: ${Size.S}px;
  height: ${Size.S}px;
  border-radius: ${IconSize.M}px;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.onSurface};
`;

export const Divider = styled.View`
  border-bottom-width: 0.5px;
  border-bottom-color: ${({ theme }) => theme.colors.disabled};
`;

export const HeaderRow = styled(Row)`
  justify-content: flex-start;
  gap: ${Size.X2_S}px;
`;

export const InfoContainer = styled.View`
  padding-horizontal: ${Size.S}px;
  gap: ${Size.S}px;
`;

export const DataContainer = styled.View`
  padding-left: ${Size.M}px;
  gap: ${Size.XS}px;
`;

export const DataItemContainer = styled.View`
  gap: ${Size.X3_S}px;
`;

export const LeftContainer = styled.View`
  width: 30%;
  background-color: ${palette.SELECTOR_GREY};
  gap: ${Size.S}px;
`;

export const RightContainer = styled.View`
  width: 70%;
  padding: ${Size.S}px;
  background-color: ${palette.AB_BRIGHT_WHITE};
  gap: ${Size.S}px;
`;

export const HospitalContactInfo = styled.View`
  gap: ${Size.X3_S}px;
  flex: 1;
  align-self: center;
  padding-left: ${Size.M}px;
`;

export const AvatarContainer = styled.View`
  border-width: 1px;
  border-radius: ${Size.M}px;
`;

export const OwnerLeftContainer = styled.View`
  gap: ${Size.X3_S}px;
`;

export const OwnerRightContainer = styled.View`
  gap: ${Size.X3_S}px;
  align-self: flex-end;
`;

export const RightSectionContainer = styled.View`
  gap: ${Size.X2_S}px;
`;

export const RightSectionDataContainer = styled.View`
  padding-left: ${Size.M}px;
  gap: ${Size.X3_S}px;
`;

export const PetNameContainer = styled.View`
  gap: ${Size.X3_S}px;
`;

export const PetNameText = styled(Caption)`
  padding-left: ${Size.M}px;
  font-weight: ${Weight.BOLD};
`;

export const GeneratedOnRow = styled(Row)`
  justify-content: flex-start;
  padding-bottom: ${Size.S}px;
  gap: ${Size.X2_S}px;
`;

export const TitleText = styled(Body)`
  font-weight: ${Weight.MEDIUM};
  padding-left: ${Size.S}px;
`;

export const HeaderButtons = styled(Row)`
  justify-content: space-between;
  padding-right: ${Size.S}px;
`;
